import { useEffect, useState } from 'react';

const Lightbox = ({ image, onClose }) => {
    const [imageLoaded, setImageLoaded] = useState(false);
    const [imageError, setImageError] = useState(false);

    // Handle escape key press
    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === 'Escape') {
                onClose();
            }
        };

        document.addEventListener('keydown', handleEscape);
        // Prevent body scroll when lightbox is open
        document.body.style.overflow = 'hidden';

        return () => {
            document.removeEventListener('keydown', handleEscape);
            document.body.style.overflow = 'unset';
        };
    }, [onClose]);

    // Handle backdrop click
    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    const handleImageLoad = () => {
        setImageLoaded(true);
    };

    const handleImageError = () => {
        setImageError(true);
        setImageLoaded(true);
    };

    return (
        <div 
            className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-1 sm:p-2"
            onClick={handleBackdropClick}
        >
            <div className="relative max-w-[98vw] max-h-[98vh] w-full h-full flex items-center justify-center">
                {/* Close button */}
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 z-10 bg-white bg-opacity-20 hover:bg-opacity-30 text-white rounded-full p-2 transition-all duration-200"
                    aria-label="Close lightbox"
                >
                    <svg 
                        className="w-6 h-6" 
                        fill="none" 
                        stroke="currentColor" 
                        viewBox="0 0 24 24"
                    >
                        <path 
                            strokeLinecap="round" 
                            strokeLinejoin="round" 
                            strokeWidth={2} 
                            d="M6 18L18 6M6 6l12 12" 
                        />
                    </svg>
                </button>

                {/* Image container with enhanced loading */}
                <div className="bg-white rounded-lg overflow-hidden shadow-2xl max-w-[90vw] max-h-[96vh] flex flex-col mx-auto">
                    <div className="relative flex items-center justify-center bg-gray-50 p-2 max-h-[80vh] overflow-hidden">
                        {/* Loading skeleton overlay */}
                        {!imageLoaded && !imageError && (
                            <div className="absolute inset-0 bg-gray-200 animate-pulse flex items-center justify-center min-h-[400px]">
                                <div className="text-center">
                                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-red-800 mx-auto mb-4"></div>
                                    <div className="text-gray-600 font-medium">Loading image...</div>
                                </div>
                            </div>
                        )}

                        {/* Error state */}
                        {imageError && (
                            <div className="flex items-center justify-center min-h-[400px] bg-gray-100 text-gray-500">
                                <div className="text-center">
                                    <svg className="w-16 h-16 mx-auto mb-4" fill="currentColor" viewBox="0 0 20 20">
                                        <path fillRule="evenodd" d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z" clipRule="evenodd" />
                                    </svg>
                                    <p className="text-lg font-medium">Failed to load image</p>
                                    <p className="text-sm mt-2">The image could not be displayed</p>
                                </div>
                            </div>
                        )}

                        {/* Actual image */}
                        <img
                            src={image.src}
                            alt={image.title}
                            className={`max-w-full max-h-full object-contain transition-opacity duration-300 ${
                                imageLoaded && !imageError ? 'opacity-100' : 'opacity-0'
                            }`}
                            style={{
                                maxHeight: '75vh',
                                maxWidth: '85vw',
                                height: 'auto',
                                width: 'auto'
                            }}
                            onLoad={handleImageLoad}
                            onError={handleImageError}
                        />
                    </div>

                    {/* Enhanced image information */}
                    <div className="p-6 border-t border-gray-200 flex-shrink-0">
                        <h3 className="text-2xl font-semibold text-gray-800 mb-3">
                            {image.title}
                        </h3>
                        
                        

                       
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Lightbox;